module.exports = __webpack_public_path__ + "static/img/93-2.572c575.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/93-2.jpg
// module id = 3VUB
// module chunks = 0